/* eslint-disable */
class MappedTreeData {
  constructor(treeData) {
    var self = this;

    self.interest = treeData["interest"] ? treeData["interest"][0] : null;
    self.children = {};

    if (treeData["children"]) {
      treeData["children"].forEach(function(child) {
        self.children[child["name"][0]] = new MappedTreeData(child);
      });
    }
  }

  getChild(path) {
    if (!Array.isArray(path))
      path = [path];

    var self = this;
    var curNode = self;

    path.forEach(function(s) {
      curNode = curNode.children[s];
    });

    return curNode;
  }

  numChildren() {
    return Object.keys(this.children).length;
  }

  getChartJsData() {
    var self = this;
    var chartJsData = {
      labels: [],
      data: []
    };

    Object.keys(self.children).forEach(function(child) {
      chartJsData.labels.push(child);
      chartJsData.data.push(self.children[child].interest * 100);
    });

    return chartJsData;
  }
}

export default MappedTreeData;



// WEBPACK FOOTER //
// ./src/modules/MappedTreeData.js